import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'flex',
  'flex-1',
  'flex-row',
  'items-center',
  'pb-3',
  'last:!pb-0'
);

interface Props {
  children: ReactNode;
  header: string;
}

const CardLineItem = ({ children, header }: Props) => (
  <div className={className}>
    <div className="flex flex-1 text-color-card-subtitle-color">{header}</div>
    <div className="flex items-center">{children}</div>
  </div>
);

export default CardLineItem;
